import { createIntl, defineMessages } from 'react-intl';
import { SingleSelectItem } from 'src/components/general-ui/SelectBoxForm';
import { hasAllPermissions } from 'src/utils/permissions';
import permissions from 'src/permissions';
import { getDeviceMountOptions } from 'src/routes/Devices/components/utils';

type LocationMountOptionsObject = {
  [key: string]: (string | boolean)[];
};
export type DropdownOptions = Record<string, SingleSelectItem[]>;
export const parseMountOptions = (
  mountOptions: LocationMountOptionsObject,
): DropdownOptions => {
  const intl = createIntl({ locale: 'en', messages: {} });
  const options: DropdownOptions = {};

  Object.entries(mountOptions).forEach(([key, values]) => {
    options[key] = values.map((value: string | boolean) => ({
      label:
        typeof value === 'boolean'
          ? value
            ? intl.formatMessage(messages.yes)
            : intl.formatMessage(messages.no)
          : // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            (getDeviceMountOptions(value, intl) as string),
      value,
    }));
  });

  return options;
};

const messages = defineMessages({
  yes: {
    id: 'modules.utils.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'modules.utils.no',
    defaultMessage: 'No',
  },
});

export const isSysAdmin = () =>
  hasAllPermissions(
    permissions.VIEW_DEVICES_ADD_BUTTON,
    permissions.VIEW_DEVICES_TENANT_ACTIONS,
    permissions.VIEW_DEVICES_TENANT_COLUMN,
    permissions.VIEW_DEVICES_EDIT_DEVICE_ACTION,
    permissions.VIEW_DEVICES_DELETE_DEVICE_ACTION,
  );
